export const SWAP_COPY = {
  previewTitle: "Axiom Swap",
  previewHint:
    "Review quotes, confirm in-app, then approve in Phantom. Mainnet execution is live.",
  connect: "Connect Wallet",
  swap: "Swap",
  swapDisabled: "Swaps are not enabled yet",
  phantomMissing:
    "Phantom is not installed. Install the Phantom extension, then try again.",
  connectionCancelled: "Connection cancelled.",
  youPay: "You Pay",
  youReceive: "You Receive",
  balance: "Balance",
  balanceUnavailable: "Balance unavailable",
  estimated: "Estimated",
  walletLocked: "Phantom is locked. Unlock it, then try again.",
  walletCannotSign: "This wallet cannot sign transactions.",
  priceImpact: "Price impact",
  minReceived: "Minimum received",
  route: "Route",
  slippage: "Slippage",
  quoting: "Fetching quote…",
  quoteUnavailable: "No trading route available.",
  staleQuote: "Quote expired. Waiting for a fresh quote…",
  insufficient: "Insufficient balance",
  solReserve: "Leave a small SOL buffer for network fees",
  invalidAmount: "Enter a valid amount",
  unsupportedToken: "This token is not supported for swap yet",
  impactElevated: "Elevated price impact",
  impactHigh: "Very high price impact — liquidity may be thin",
  unverifiedRisk: "Unverified token — discovery is not a safety check",
  pending: "Confirm in wallet…",
  preparing: "Preparing transaction…",
  submitted: "Transaction submitted",
  confirmingOnchain: "Confirming on Solana...",
  success: "Swap successful",
  confirmed: "Confirmed on Solana",
  failure: "Transaction failed",
  cancelled: "Transaction cancelled",
  expired: "Transaction expired",
  slippageExceeded: "Slippage exceeded",
  networkError: "RPC/network error",
  disconnected: "Connect a wallet to continue",
  selectToken: "Select a token",
  searchPlaceholder: "Search name, symbol, or mint",
  comingSoon: "Coming soon",
  unverified: "Unverified",
  unknownMeta: "Unknown metadata",
  noResults: "No tokens found",
  popular: "Popular",
  trending: "Trending",
  newPump: "New / Pump.fun",
  marketUnavailable: "Market data unavailable",
  slippageInvalid: "Enter a slippage between 0.01% and 10%",
  confirmTitle: "Confirm swap",
  confirmSwap: "Confirm Swap",
  cancel: "Cancel",
  confirmGated:
    "Review only — swaps are not enabled yet. No wallet prompt will open.",
  max: "Max",
  token: "Token",
  mint: "Mint",
  network: "Network",
  networkMainnet: "Solana Mainnet",
  pairMismatch: "Token pair changed. Request a fresh quote.",
  submitInFlight: "Transaction already in progress.",
  confirmationUnknown:
    "Transaction submitted. Confirmation is still pending — do not submit again.",
  valuesUpdated: "Quote updated — review the new amounts, then Confirm again.",
  viewTransaction: "View on Solscan",
  amountPaid: "Amount paid",
  amountReceived: "Token received",
  signature: "Signature",
} as const;
